import { memo } from "react";

import { CartUpsellCarousel } from "@cart/CartUpsellCarousel";
import { CartUpsellPlaceholder } from "@cart/CartUpsells/CartUpsellPlaceholder";
import { Badge } from "@react/components/Badge";
import { Text } from "@react/components/Text";
import { type CartUpsellProductMetadata } from "@tablescape/state";
import { tw } from "classnames";

type Props = {
  badgeText: string | undefined;
  headingText: string;
  upsellMetadata: CartUpsellProductMetadata[] | undefined;
};

const styles = {
  container: tw("py-4"),
  upsellHeading: tw("flex", "items-center", "gap-2", "px-6", "pb-3"),
};

const CartUpsellsViewBase = ({
  badgeText,
  headingText,
  upsellMetadata,
}: Props) => {
  return !Array.isArray(upsellMetadata) || upsellMetadata.length ? (
    <div className={styles.container}>
      {Array.isArray(upsellMetadata) ? (
        <>
          <div className={styles.upsellHeading}>
            <Text>{headingText}</Text>
            {badgeText && <Badge size="sm">{badgeText}</Badge>}
          </div>
          <CartUpsellCarousel upsellMetadata={upsellMetadata} />
        </>
      ) : (
        <CartUpsellPlaceholder />
      )}
    </div>
  ) : null;
};

export const CartUpsellsView = memo(CartUpsellsViewBase);
